import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import { useEffect } from "react";

const GET_EXPENSE_REPORTS = gql`
  query ExpenseReports($sliceNumber: Int!) {
    expenseReports(expenseReportsRequest: { sliceNumber: $sliceNumber }) {
      expenses {
        uuid
        expenseReportFileUuid
        createdAt
        invoiceDate
        category {
            accountingAccountNumber
            labelFr
            labelEn
            label
            uuid
            }
        status
        amountExcludingVat
        impactsOverflow
        currency
        countryCode
        comment
        paymentDate
        totalAmount
        invoiceIssuer
        boondManagerId
        vatList {
          vatRate
          vatAmount
          vatUuid
        }
          adminComment
      }
      hasNext
    }
  }
`;


export const useExpenseReports = (sliceNumber) => {

    const { loading, error, data, refetch } = useQuery(GET_EXPENSE_REPORTS, {
        variables: { sliceNumber },
    });

    useEffect(()=>{
        refetch()
    }, [sliceNumber])

    return { loading, error, expenseReports: data?.expenseReports, refetch };
};
